import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import FirstPage from "./Pages/Front-page";
import HomePage from "./Pages/Home-page";

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<FirstPage />} />
        <Route path="/home" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
